import { apiFetch, ApiError } from './client.js';

/**
 * A parent cancels one athlete's lesson. Nothing is charged, and the coach
 * sees it on his day. The API refuses a lesson that is not on this account,
 * and one whose hour has started.
 */
export async function cancelLessonAsParent(
  getToken: () => Promise<string | null>,
  lessonId: string,
): Promise<void> {
  try {
    await apiFetch<unknown>(`/api/lessons/${lessonId}/cancel`, getToken, { method: 'POST' });
  } catch (cause) {
    throw startedOr(cause);
  }
}

/**
 * The screen was opened before the hour and confirmed after it. "Try again"
 * would be wrong — it will never work — so say why instead.
 */
export function startedOr(cause: unknown): unknown {
  return cause instanceof ApiError && cause.code === 'lesson_started'
    ? new Error('This lesson has started, so it can no longer be cancelled.')
    : cause;
}
